import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, HeartHandshake } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/donate-items", label: "Donate Items", testid: "nav-donate-items-link" },
  { to: "/shop", label: "Shop Affordable Furniture", testid: "nav-shop-link" },
  { to: "/support", label: "Support Us", testid: "nav-support-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/partners", label: "Partners", testid: "nav-partners-link" },
  { to: "/volunteers", label: "Volunteer", testid: "nav-volunteers-link" },
  { to: "/contact", label: "Contact", testid: "nav-contact-link" },
];

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-all duration-300 ${
        scrolled ? "border-linen bg-cream/90 backdrop-blur-md shadow-sm" : "border-transparent bg-cream/60 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src="/logo.png" alt="Fresh Start Furnishings" className="h-12 w-auto sm:h-14" />
        </Link>
        <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={n.testid}
              className={({ isActive }) =>
                `rounded-full px-3.5 py-2 text-[13px] font-medium tracking-wide transition-colors duration-200 ${
                  isActive ? "bg-olive text-cream" : "text-moss hover:bg-beige hover:text-olive"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/donate-items" data-testid="header-donate-cta" className="btn-accent hidden !px-5 !py-2.5 text-xs sm:inline-flex">
            <HeartHandshake className="h-4 w-4" /> Donate
          </Link>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="rounded-full border border-linen p-2.5 text-olive lg:hidden"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-nav" className="border-t border-linen bg-cream px-4 pb-6 pt-2 lg:hidden" aria-label="Mobile">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`mobile-${n.testid}`}
              className={({ isActive }) =>
                `block rounded-xl px-4 py-3 text-base font-medium ${isActive ? "bg-olive text-cream" : "text-moss hover:bg-beige"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
}
